import React, { useEffect, useRef, useState } from 'react';
import { formatEuro, isBuilding, PROPERTIES, SERVICE_NAMES } from './model';
import { Icon } from './Icon';

export const AnimatedPrice = ({ total, ready, testid }) => {
  const [display, setDisplay] = useState(total);
  const previous = useRef(total);
  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { setDisplay(total); previous.current = total; return; }
    const start = performance.now(), from = previous.current;
    let frame;
    const animate = (time) => {
      const progress = Math.min((time - start) / 220, 1);
      setDisplay(from + (total - from) * (1 - (1 - progress) ** 3));
      if (progress < 1) frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate); previous.current = total;
    return () => cancelAnimationFrame(frame);
  }, [total]);
  return <span className="sim-amount" data-testid={testid} aria-label={ready ? formatEuro(total) : 'Prix à préciser'}><span aria-hidden="true">{ready ? formatEuro(display) : '—'}</span></span>;
};

export const Enzo = ({ mobile = false }) => <div className={`sim-enzo ${mobile ? 'sim-enzo-mobile' : ''}`} data-testid={mobile ? 'enzo-mobile' : 'enzo-summary'}>
  <img src="/assets/enzo.webp" width="52" height="52" alt="Enzo, diagnostiqueur certifié" decoding="async" />
  <p><strong>Enzo, diagnostiqueur certifié,</strong><br />vous explique le rapport au téléphone.</p>
</div>;

export function summaryLines(data, selected, services) {
  const lines = [];
  const property = PROPERTIES.find((item) => item.id === data.property_type);
  if (property) lines.push({ key: 'property', label: property.label, value: isBuilding(data.property_type) ? (data.lot_count ? `${data.lot_count} lots` : '') : (data.surface ? `${data.surface} m²${data.surface_range ? ' env.' : ''}` : '') });
  if (data.address) lines.push({ key: 'address', label: data.address, address: true });
  for (const [key, on] of Object.entries(selected)) {
    if (on && services[key]) lines.push({ key, label: SERVICE_NAMES[key] || services[key].name, value: formatEuro(services[key].price_ttc) });
  }
  if (data.property_type === 'immeuble' && selected.pppt && !selected.dpe_immeuble) lines.push({ key: 'included', label: 'DPE à l’immeuble', value: 'Inclus' });
  if (services.reequilibrage && (selected.pppt || selected.dpe_collectif || selected.dpe_immeuble || selected.audit_energetique)) lines.push({ key: 'reequilibrage', label: 'Réglage des organes d’équilibrage', value: 'Offert' });
  return lines;
}

export const Summary = ({ data, selected, services, total, ready }) => {
  const lines = summaryLines(data, selected, services);
  return <aside className="sim-summary-column" data-testid="summary-panel">
    <div className="sim-summary">
      <div className="sim-summary-heading"><h2>Votre devis</h2><Icon name="file" size={21} /></div>
      <div className="sim-summary-lines">
        {!lines.length && <p className="sim-summary-empty" data-testid="summary-empty">Votre projet se précise,<br />votre devis aussi.</p>}
        {lines.map((line) => <div key={line.key} className={`sim-summary-line ${line.address ? 'sim-summary-address' : ''}`} data-testid={`summary-${line.key}`}><span>{line.address && <Icon name="pin" size={15} />}{line.label}</span>{line.value && <strong>{line.value}</strong>}</div>)}
        {!Object.values(selected).some(Boolean) && data.property_type && <p className="sim-summary-empty" data-testid="summary-services-empty">Vos prestations s’afficheront ici.</p>}
      </div>
      <div className="sim-summary-total"><span>Total TTC</span><AnimatedPrice total={total} ready={ready} testid="summary-total-ttc" /><small data-testid="summary-price-terms">Prix ferme · TTC · déplacement inclus</small></div>
      <Enzo />
    </div>
    <div className="sim-trust" data-testid="trust-panel">
      <div className="sim-google" data-testid="google-rating"><span className="sim-stars" aria-hidden="true">{[0,1,2,3,4].map((n) => <Icon key={n} name="star" size={14} />)}</span><strong>4,9/5</strong><span>sur Google</span></div>
      <p data-testid="trust-certified"><Icon name="shield" size={18} /> Diagnostiqueur certifié</p>
      <p data-testid="trust-visit"><Icon name="clock" size={18} /> Intervention sous 48 h</p>
      <p data-testid="trust-report"><Icon name="file" size={18} /> Rapport 24 h après la visite</p>
    </div>
  </aside>;
};